export default __webpack_public_path__ + "static/media/marginalia-family-1.4b5f278b.svg";